<is-be-auth [environmentKey]="environmentKey" #isbeauth></is-be-auth>
<div
  *ngIf="dispContent; else elseBlock"
  class="l-app"
  igxLayout
  igxLayoutDir="row"
>
  <is-igx-app-header
    [environmentKey]="environmentKey"
    [title]="title"
    [routerItems]="false"
    [navItems]="navItems"
    (logout)="logout()"
  >
  </is-igx-app-header>
  <main class="l-main" igxFlex>
    <app-message></app-message>
    <router-outlet></router-outlet>
  </main>
</div>
<ng-template #elseBlock>
  @if(showNoPermission){
  <div class="no-permission">参照権限がありません</div>
  } @else{
  <div class="loading-mask">
    <div class="loading-msg">ログイン中...</div>
  </div>
  }
</ng-template>
